export default "__VITE_ASSET__CVruAfH___"